"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegwizardService = void 0;
class RegwizardService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Chathost Reg State
     * @returns RegisterStepsResponseModel Successful Response
     * @throws ApiError
     */
    chathostChathostRegState() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/regwizard/steps',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Chathost New Register
     * @param requestBody
     * @param ran
     * @param ranVisitor
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostChathostNewRegister(requestBody, ran, ranVisitor) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/regwizard/new',
            cookies: {
                'Ran': ran,
                'RanVisitor': ranVisitor,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
}
exports.RegwizardService = RegwizardService;
